import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars} from 'react-icons/fa';
import { FaInstagram, FaFacebookF } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
function Nav({ panel, admin }) {
const [isOpen, setIsOpen] = useState(false);
const navRef = useRef();
const location = useLocation();
const local = location.pathname.split('/')[1] || 'olkusz';
const closeMenu = () => setIsOpen(false);

useEffect(() => {
function handleClickOutside(event) {
    if (isOpen && navRef.current && !navRef.current.contains(event.target)) {
    setIsOpen(false);
    }
}

document.addEventListener('mousedown', handleClickOutside);
return () => document.removeEventListener('mousedown', handleClickOutside);
}, [isOpen]);

return (
<header className="w-full  shadow-xl fixed top-0 left-0 z-50">
    <div className="flex items-center justify-between px-4 py-3 xl:py-2 xl:px-8">
    <div className="flex items-center gap-2">
        <h1 className="text-lg font-semibold">Maciej Głąb</h1>
    </div>

    <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-3xl xl:hidden z-51"
        aria-label="Toggle menu"
    >
        <FaBars />
    </button>

    <nav
        ref={navRef}
        className={`fixed top-0 right-0 h-full w-2/3 p-6 pt-20 transition-transform duration-300 ease-in-out transform xl:static xl:h-auto xl:w-auto xl:p-0 xl:transform-none z-50 ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
    >
        <button
        className="absolute top-4 right-4 xl:hidden text-7xl font-bold"
        onClick={closeMenu}
        aria-label="Close menu"
        >
        &times;
        </button>
        {admin && <ul className="flex flex-wrap gap-4 items-center">
  <li>
    <Link
      to="/admin/upload"
      onClick={closeMenu}
      className="text-sm font-semibold px-3 py-1"
    >
      Client list
    </Link>
  </li>

  <li>
    <Link
      to="/admin/blog"
      onClick={closeMenu}
      className="text-sm font-semibold px-3 py-1 rounded border border-gray-200 hover:bg-gray-100"
    >
      Edytor bloga
    </Link>
  </li>

</ul>}
{local && (
  <ul className="flex flex-col items-center gap-6 font-medium xl:flex-row xl:gap-8 xl:items-center xl:justify-center mt-6 xl:mt-0 text-2xl xl:text-lg">
    <li>
      <Link to={`/${local}`} onClick={closeMenu}>Strona główna</Link>
    </li>
    {!panel && <>
    <li>
      <Link to={`/${local}/oferta`} onClick={closeMenu}>Oferta</Link>
    </li>
    <li>
      <Link to={`/${local}/blog`} onClick={closeMenu}>Blog</Link>
    </li>
    <li>
      <Link to={`/${local}/kontakt`} onClick={closeMenu}>Kontakt</Link>
    </li></>}
    <li className="flex gap-4 mt-4 xl:mt-0">
      <a
        href="https://www.instagram.com/saunamaster.eu/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-pink-600 hover:text-pink-800 text-2xl"
        aria-label="Instagram"
      >
        <FaInstagram />
      </a>
      <a
        href="..."
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 hover:text-blue-600 text-2xl"
        aria-label="Facebook"
      >
        <FaFacebookF />
      </a>
    </li>
  </ul>
)}
    </nav>
    </div>
</header>
);
}

export default Nav;
